import React, { useCallback } from 'react';
import { AccessSwitchItemProps } from './types';

import styles from './access-switch-item.scss';

export const AccessSwitchItem: React.FC<AccessSwitchItemProps> = ({
  item, disabled, checked, isValid, readOnly, readOnlyLabel, onChange
}) => {

  const changeHandler = !readOnlyLabel
    ? useCallback(
      () => {
        onChange(item, !checked);
      }, [item, checked, onChange])
    : undefined;

  return (<li className={isValid ? styles.switchComponent : styles.invalidSwitchComponent} key={item.value}>
    <span className={`${styles.switchLabel} ${disabled ? styles.switchLabelDisabled : ''}`}>{item.description}</span>
    <div className={styles.switchContainer}>
      <label className={`${styles.switch} ${readOnlyLabel ? styles.infoTextTrigger : ''}`}>
        <input
          type="checkbox"
          className="visuallyhidden"
          name={JSON.stringify(item.value)}
          onChange={changeHandler}
          checked={checked}
          disabled={readOnly}
          tabIndex={readOnlyLabel ? -1 : 0}
        />
        <span className={`${styles.slider} ${readOnly ? styles.uiSwitchDisabled : ''}`} />
        {!!readOnlyLabel && <>
          <svg viewBox="0 0 20 20">
            <path className={styles.tooltipArrow} d="M4,0H16L10,6Z" transform="translate(-4)" />
          </svg>
          <div className={styles.infoText}>{readOnlyLabel}</div>
        </>}
      </label>
    </div>
  </li>);
};
